import {Layout, Typography, Divider, Image} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Paragraph} = Typography;
const {Content} = Layout;

const CommunicationAP = () => {
  return (
    <Layout style={{margin: '80px 50px 50px 50px', background: 'inherit'}}>
      <Paragraph className='Title3' style={{color: appColors['ColorX'], marginTop: '-4%'}}>Activities with the public</Paragraph>
      <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '-2%'}}>Quizzes</Paragraph>
      <Layout style={{background: 'inherit', width: 'fit-content', display: 'block'}}>
        <Content style={{float: 'left', background: 'inherit'}}>
          <Paragraph className='BaseText3'>To engage and reaffirm the content we presented in the several series of our posts, after every publication we uploaded Instagram stories that asked about the topic we previously posted. Most of them were multiple choice questions and at the end we invited them to display how many correct answers they got. In these activities we demonstrated that our followers liked this type of interaction and found it useful for learning.</Paragraph>
        </Content>
        <Content style={{width: 'fit-content', display: 'block', background: appColors['ColorG'], marginLeft: '60%'}}>
          <Image.PreviewGroup>
            <Image width={'50%'} src='https://static.igem.wiki/teams/4464/wiki/communication/quizzes-25.png'></Image>
            <Image width={'50%'} src= 'https://static.igem.wiki/teams/4464/wiki/communication/quizzes-26.png'></Image>
            <p>Quizzes made to our followers on instagram.</p>
          </Image.PreviewGroup>
        </Content>
      </Layout>
      <Divider/>
      <Layout style={{background: appColors['ColorG'], width: 'fit-content', display: 'block'}}>
        <Content style={{float: 'left', marginLeft: '5%', background: appColors['ColorG'], display: 'block', maxWidth: '40%'}}>
          <Image.PreviewGroup>
            <Image width={'50%'} src='https://static.igem.wiki/teams/4464/wiki/communication/challenges-27.png'></Image>
            <Image width={'50%'} src= 'https://static.igem.wiki/teams/4464/wiki/communication/challenges-28.png'></Image>
            <p>Challenges made to our followers on instagram.</p>
          </Image.PreviewGroup>
        </Content>
        <Content style={{width: 'fit-content', marginLeft: '50%', background: 'inherit'}}>
          <Paragraph className='Title4' style={{color: appColors['ColorC']}}>Challenges</Paragraph>
          <Paragraph className='BaseText'>Another strategy we implemented were several challenges to help science concepts reach more people among our community. For example, we asked them to share through their social media a person from STEM that inspires them, here are some of the results:</Paragraph>
        </Content>
      </Layout>
    </Layout>
  );
};

export default CommunicationAP;
